import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const Blaze = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 16 }, forwardedRef) => {
  return (
    <svg
      width={size}
      height={size}
      style={{ width: size, height: size }}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={forwardedRef}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.10631 8.15539L11.591 5.71825C12.4172 4.75714 12.8204 3.59391 12.5625 2.61012C12.2732 1.50395 11.2232 0.933336 9.94604 1.00621L6.10631 8.15539ZM3.63654 9.89405L3.63656 9.89401L3.63656 9.89404L3.63654 9.89405ZM4.17553 15L7.01712 8.73907L3.63656 9.89404L4.17553 15ZM4.17553 15L10.5225 12.8296C12.8695 12.0266 14.4134 9.68024 13.9018 7.7264C13.6132 6.62367 12.7208 5.92381 11.591 5.73269L4.17553 15ZM3.63656 9.89401L3 3.86341L6.5641 2.2265L3.63656 9.89401Z"
        fill={color}
      />
    </svg>
  )
})

export default Blaze
